var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExport = function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "export_svg2__a",
    x1: 50.74,
    x2: 174.06,
    y1: 203.69,
    y2: 54.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m67 56.82 23-23.03v96.12c0 6.01 4 10.01 10 10.01s10-4.01 10-10.01V33.79l23 23.03c4 4.01 10 4.01 14 0s4-10.01 0-14.02L107 2.75c-1-1-2-2-3-2-2-1-5-1-8 0-1 0-2 1-3 2L53 42.8c-4 4.01-4 10.01 0 14.02s10 4.01 14 0m123 63.08c-6 0-10 4.01-10 10.01v40.05c0 6.01-4 10.01-10 10.01H30c-6 0-10-4.01-10-10.01v-40.05c0-6.01-4-10.01-10-10.01s-10 4.01-10 10.01v40.05C0 186.98 13 200 30 200h140c17 0 30-13.02 30-30.04v-40.05c0-6.01-4-10.01-10-10.01",
    style: {
      fill: "url(#export_svg2__a)",
      strokeWidth: 0
    }
  }));
};
export default SvgExport;